"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
var BrowserUtil_1 = __importDefault(require("../BrowserUtil"));
var NodeJSUtil_1 = __importDefault(require("../NodeJSUtil"));
var AppConfigService_1 = __importDefault(require("./AppConfigService"));
var EnvUtil_1 = require("../EnvUtil");
var nodeEnv = NodeJSUtil_1.default.getNodeEnv() || 'dev';
var appConfig = AppConfigService_1.default.appConfig();
var AppService = /** @class */ (function () {
    function AppService() {
    }
    AppService.serverHost = function () {
        var origin = AppConfigService_1.default.getOrigin();
        if (origin === '//localhost:9021' || origin === '//localhost:3000') {
            return '//localhost:9020';
        }
        if (origin.includes('.local.') || origin.includes('localhost')) {
            if (AppConfigService_1.default.isSsl()) {
                return 'https://web.local.aperza.com:9020';
            }
            return 'https://web.local.aperza.com:9020';
        }
        if (origin.includes('storybook.')) {
            return 'https://web.test.aperza.com';
        }
        var appConfig = this.appConfig();
        return "https://web" + appConfig.baseComDomain;
    };
    AppService.cloudServerHost = function () {
        var env = EnvUtil_1.EnvUtil.getAppEnv();
        var serverUrl = 'https://cloud.local.aperza.com:18010';
        if (env === EnvUtil_1.EnvUtil.ENV_TEST || env === EnvUtil_1.EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://cloud.test.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://cloud.test2.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_STG) {
            serverUrl = 'https://cloud.stg.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_PROD) {
            serverUrl = 'https://cloud.aperza.com';
        }
        return serverUrl;
    };
    AppService.wwwServerHost = function () {
        var env = EnvUtil_1.EnvUtil.getAppEnv();
        var serverUrl = 'https://www.local.aperza.com:8280';
        if (env === EnvUtil_1.EnvUtil.ENV_TEST || env === EnvUtil_1.EnvUtil.ENV_STORYBOOK) {
            serverUrl = 'https://www.test.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://www.test2.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_STG) {
            serverUrl = 'https://www.stg.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_PROD) {
            serverUrl = 'https://www.aperza.com';
        }
        return serverUrl;
    };
    AppService.staticServerHost = function () {
        var env = EnvUtil_1.EnvUtil.getAppEnv();
        var serverUrl = 'https://static.test.aperza.com'; // make local/test is same
        if (env === EnvUtil_1.EnvUtil.ENV_TEST_2) {
            serverUrl = 'https://static.test2.aperza.com';
        }
        if (env === EnvUtil_1.EnvUtil.ENV_STG) {
            serverUrl = 'https://static.stg.aperza.com';
        }
        else if (env === EnvUtil_1.EnvUtil.ENV_PROD) {
            serverUrl = 'https://static.aperza.com';
        }
        return serverUrl;
    };
    AppService.isDevelopment = function () {
        return nodeEnv === 'dev';
    };
    AppService.isErrorPage = function () {
        var pathName = BrowserUtil_1.default.getPath();
        return pathName.indexOf('error') > -1;
    };
    AppService.isMainPage = function () {
        var pathName = BrowserUtil_1.default.getPath();
        return (pathName === '/' ||
            pathName === '/en' ||
            pathName === '/en/' ||
            pathName.startsWith('/en/?') ||
            pathName === '/ja' ||
            pathName === '/ja/' ||
            pathName.startsWith('/ja/?'));
    };
    AppService.staticUrl = function (path) {
        var host = appConfig.cdnHost;
        return "" + host + path;
    };
    AppService.encodedPath = function () {
        var encodedPath = '';
        // https://aperza.atlassian.net/browse/AB-5120
        // Exception for order
        if (appConfig.serviceType === 'aperza-order') {
            return encodedPath;
        }
        var path = (BrowserUtil_1.default.getPath() + BrowserUtil_1.default.getSearch()).replace(/^\/+/, '');
        if (path !== '/') {
            encodedPath = encodeURIComponent(path);
        }
        return encodedPath;
    };
    AppService.encodedPathParameter = function () {
        return "&path=" + this.encodedPath();
    };
    AppService.appConfig = function () {
        return appConfig;
    };
    return AppService;
}());
exports.AppService = AppService;
exports.default = AppService;
//# sourceMappingURL=AppService.js.map